"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var FreeStyle = require("free-style");

exports.FreeStyle = FreeStyle;

var helpers = require("style-helper");

exports.helpers = helpers;
/**
 * Tag the element for rendering later.
 */

exports.STYLE_ID = '_react_free_style_';
/**
 * Check whether we can render on the server/browser.
 */

exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
/**
 * Create a global style container.
 */

var globalStyle = FreeStyle.create();
/**
 * Create and append a style element to the DOM.
 */

var addStyle = exports.canUseDOM ? function (cache, counters) {
  return function (Style, componentName) {
    if (!counters[Style.id]) {
      var element_1 = document.createElement('style');
      element_1.setAttribute('type', 'text/css');
      element_1.setAttribute('data-react-free-style', Style.id);
      element_1.setAttribute('data-react-component', componentName);
      element_1.textContent = Style.getStyles();
      document.head.appendChild(element_1);

      cache[Style.id] = function () {
        if (counters[Style.id] === 1) {
          delete cache[Style.id];
          delete counters[Style.id];
          document.head.removeChild(element_1);
          return;
        }

        counters[Style.id]--;
      };

      counters[Style.id] = 0;
    }

    counters[Style.id]++;
    return cache[Style.id];
  };
}(Object.create(null), Object.create(null)) : function (Style) {
  var global = globalStyle;
  global.merge(Style);
  return function () {
    global.unmerge(Style);
  };
};
/**
 * Create the context object for style components.
 */

function createStyleContext(name) {
  var Style = FreeStyle.create();

  var _unmount = addStyle(Style, name);

  function wrap(invoke) {
    var result = invoke();

    _unmount();

    _unmount = addStyle(Style, name);
    return result;
  }

  return {
    registerStyle: function registerStyle(styles, displayName) {
      return wrap(function () {
        return Style.registerStyle(styles, displayName);
      });
    },
    registerCss: function registerCss(css) {
      return wrap(function () {
        return Style.registerCss(css);
      });
    },
    registerHashRule: function registerHashRule(prefix, styles, displayName) {
      return wrap(function () {
        return Style.registerHashRule(prefix, styles, displayName);
      });
    },
    registerKeyframes: function registerKeyframes(keyframes, displayName) {
      return wrap(function () {
        return Style.registerKeyframes(keyframes, displayName);
      });
    },
    registerRule: function registerRule(rule, styles) {
      return wrap(function () {
        return Style.registerRule(rule, styles);
      });
    },
    unmount: function unmount() {
      return _unmount();
    }
  };
}

exports.createStyleContext = createStyleContext;
/**
 * Get the current render styles.
 */

function rewind() {
  if (exports.canUseDOM) {
    throw new TypeError('You must call `rewind()` on the server. Call `peek()` to read the current styles.');
  }

  var styles = peek();
  globalStyle = FreeStyle.create();
  return styles;
}

exports.rewind = rewind;
/**
 * The interface for "peeking" results.
 */

var Peek = function () {
  function Peek(Style) {
    this.Style = Style;
  }

  Peek.prototype.toComponent = function () {
    return React.createElement('style', {
      id: exports.STYLE_ID,
      dangerouslySetInnerHTML: {
        __html: this.Style.getStyles()
      }
    });
  };

  Peek.prototype.toString = function () {
    return "<style id=\"" + exports.STYLE_ID + "\">" + this.Style.getStyles() + "</style>";
  };

  Peek.prototype.toCss = function () {
    return this.Style.getStyles();
  };

  return Peek;
}();

exports.Peek = Peek;
/**
 * Peek at the current styles without clearing.
 */

function peek() {
  return new Peek(globalStyle);
}

exports.peek = peek;
/**
 * Create a style component.
 */

var StyleComponent = function (_super) {
  __extends(StyleComponent, _super);

  function StyleComponent() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  StyleComponent.prototype.componentWillMount = function () {
    this.unmountStyle = addStyle(this.props.Style, this.props.componentName);
  };

  StyleComponent.prototype.componentWillUpdate = function (nextProps) {
    if (this.props.Style.id === nextProps.Style.id) return;
    this.unmountStyle();
    this.unmountStyle = addStyle(nextProps.Style, nextProps.componentName);
  };

  StyleComponent.prototype.componentWillUnmount = function () {
    this.unmountStyle();
    if (this.freeStyle) this.freeStyle.unmount();
  };

  StyleComponent.prototype.render = function () {
    var _a = this.props,
        componentProps = _a.componentProps,
        Component = _a.Component,
        withFreeStyle = _a.withFreeStyle;
    var props = withFreeStyle ? Object.assign({}, componentProps, {
      freeStyle: this.freeStyle || (this.freeStyle = createStyleContext(this.props.componentName))
    }) : componentProps;
    return React.createElement(Component, props);
  };

  StyleComponent.displayName = 'Style';
  return StyleComponent;
}(React.Component);

exports.StyleComponent = StyleComponent;
/**
 * Wrap a component instead of adding it to the markup manually.
 */

function wrap(Component, Style, withFreeStyle, name) {
  if (name === void 0) {
    name = 'anonymous';
  }

  var componentName = Component.displayName || Component.name || name;

  var Wrapped = function Wrapped(componentProps) {
    return React.createElement(StyleComponent, {
      Style: Style,
      Component: Component,
      componentName: componentName,
      componentProps: componentProps,
      withFreeStyle: withFreeStyle
    });
  };

  Wrapped.displayName = "Wrap(" + componentName + ", Style)";
  return Wrapped;
}

exports.wrap = wrap;
/**
 * Create a HOC for styles.
 */

function styled(sheet, options, hash, debug) {
  if (sheet === void 0) {
    sheet = {};
  }

  var Style = FreeStyle.create(hash, debug);
  var styles = helpers.registerStyleSheet(Style, sheet, options);
  return Object.assign(function (Component, withFreeStyle) {
    var componentName = Component.displayName || Component.name || 'anonymous';

    var Styled = function Styled(props) {
      var componentProps = Object.assign({}, props, {
        styles: props.styles ? Object.assign({}, styles, props.styles) : styles
      });
      return React.createElement(StyleComponent, {
        Style: Style,
        Component: Component,
        componentName: componentName,
        componentProps: componentProps,
        withFreeStyle: withFreeStyle
      });
    };

    Styled.displayName = "Styled(" + componentName + ")";
    return Styled;
  }, {
    Style: Style,
    styles: styles
  });
}

exports.styled = styled;